export default {
  regular: {
    height: '48px',
    minHeight: '48px',
    '@media (min-width: 600px)': {
      minHeight: '48px',
    },
  },
};
